export default __webpack_public_path__ + "static/media/bullet-main.79b32bd7.png";